exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\naside.pcoded-slider.ng-sidebar {\n  top: 56px; }\n\n.slimscroll-wrapper, .scroll-window {\n  width: 100% !important; }\n\n.userlist-box.show {\n  display: -webkit-box; }\n\n.userlist-box.hide {\n  display: none; }\n\n/* p{\r\n    color: coral;\r\n} */\n.scroll-bar {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: -17px;\n  overflow-y: scroll;\n  overflow: hidden; }\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 3px rgba(233, 229, 229, 0.3);\n  background-color: #F5F5F5; }\n\n::-webkit-scrollbar {\n  width: 3px;\n  background-color: #F5F5F5; }\n\n::-webkit-scrollbar-thumb {\n  background-color: #fffafa; }\n\n.scrollbar {\n  background: #F5F5F5;\n  overflow-y: scroll;\n  width: 500px;\n  height: 650px;\n  top: 0;\n  bottom: 0;\n  left: 0; }\n\n.force-overflow {\n  min-height: 450px; }\n\na:hover {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/layouts/admin/notification-layout/notification-layout.component.scss
// module id = ../../../../../src/app/layouts/admin/notification-layout/notification-layout.component.scss
// module chunks = main